<template>
  <div class="wrapper">
    <div>
      <strong> {{ $t('dashboard.action') }}: </strong>
      <strong>
        <template v-if="myActionsIds.length > 0">
          {{myActionName}}
          {{
            myActionsIds.length - 1 !== 0 ? ` + ${myActionsIds.length - 1}` : ''
          }}

          <template v-if="myActionsIds.length > 1">
            <span id="info-action">
              <font-awesome-icon
                :icon="['fas', 'info-circle']"
                style="font-size: 15px; color: #c1c1c1"
              />
            </span>

            <b-popover target="info-action" triggers="hover" placement="right">
              {{ returnFilterActionsNames() }}
            </b-popover>
          </template>
        </template>
        <template v-else-if="!loadingActionSelected && myActionsIds.length === 0">{{ $t('menu.allActionsLabel') }}</template>
      </strong>
    </div>
    <div>
      <strong> {{ $t('dashboard.period') }}: </strong>
      <span>
        <span style="font-weight: 100">{{ showPeriod() }}</span>
      </span>
      <vc-date-picker
        :locale="countryLanguage"
        mode="range"
        v-model="dates"
        color="green"
        :max-date="maxDate"
        :min-date="minDate"
      >
        <font-awesome-icon
          :icon="['fas', 'calendar-alt']"
          class="ml-2 calendar-icon"
          style="font-size: 18px"
        />
      </vc-date-picker>
    </div>
    <!-- <div v-if="filter1">
      <strong>Filtro
        <span v-if="company.indicatorIh1">
          por {{company.indicatorIh1}}
        </span>:
      </strong> {{ filter1 }}
    </div>
    <div v-if="filter2">
      <strong>Filtro
        <span v-if="company.indicatorIh2">
          por {{company.indicatorIh2}}
        </span>:
      </strong> {{ filter2 }}
    </div> -->
    <div style="padding-left: 15px">
      <b-form-select
        v-model="calendarDates.selected"
        @change="selectOption"
        :options="fastFilter"
      >
        <b-form-select-option
          v-for="(item, index) in customFilters"
          :key="index"
          :value="item.name"
          >{{ item.name }}</b-form-select-option
        >
      </b-form-select>
    </div>
    <div v-if="refreshButton">
      <span style="padding-left: 6px">
        <i
          style="color: #4ce595; cursor: pointer; font-size: 18px"
          class="fas fa-sync-alt"
          @click="refreshData"
          :title="`${this.$t('dashboard.updateList')}`"
        ></i>
      </span>
    </div>
    <slot name="btn-refresh"></slot>
    <slot name="menu-reports"></slot>
    <slot name="export-pdf"></slot>
    <div class="volumes">
      <slot name="dashboard-items"></slot>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { format, lightFormat } from 'date-fns';
import * as moment from 'moment';
import EventBus from '../../../eventBus';
import api from '../../../services/api';

export default {
  name: 'DashboardBar',
  props: {
    refreshButton: {
      type: Boolean,
    },
    reports: {
      type: Boolean,
    },
    consumption: {
      type: Boolean,
    },
    noAllPeriod: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data: () => ({
    dates: {
      start: null,
      end: +new Date(),
      selected: 'Personalizado',
    },
    formattedDate: {
      start: null,
      end: null,
    },
    myDates: {
      start: null,
      end: null,
      selected: '',
    },
    userAuth: null,
    filter1: null,
    filter2: null,
    countryLanguage: 'pt',
    // selected: 'Últimos 30 dias',
    fastFilter: [],
    customFilters: [],
    maxDate: new Date(),
    isInviteStatus: false,
    minDate: null,
    loadingActionSelected: false,
    listAllActions: []
  }),
  watch: {
    dates: async function watchDates(dates) {

      if (dates) {
        this.calendarDates.selected = 'Personalizado';
        this.formattedDate.start = this.dateFormat(dates.start);
        this.formattedDate.end = this.dateFormat(dates.end);
        this.myDates.start = dates.start;
        this.myDates.end = dates.end;
        this.myDates.selected = this.calendarDates.selected;
        this.setDates({
          start: this.formattedDate.start,
          end: this.formattedDate.end,
          selected: this.calendarDates.selected,
        });

        EventBus.$emit('change-dates', dates);
      }
    },

    calendarDates: function watchCalendarDates(value) {
      // if (value.start === null) {
      //   this.myDates.start = null;
      //   this.myDates.end = null;
      //   this.dates.start = null;
      //   this.dates.end = null;
      // }
    },

    myIh1: function watchMyIh1(value) {
      if (value !== '0') {
        const item = this.ih1.listFilters.find((obj) => obj._id === value);
        this.filter1 = item.corporate_name;
      } else {
        this.filter1 = null;
      }
    },

    myHierarchies1: function watchMyHierarchies1(arrayIds) {
      if (arrayIds.lenght > 0) {
        const item = this.ih1.listFilters.find(
          (obj) => obj._id === arrayIds[0],
        );
        this.filter1 = item.corporate_name;
      } else {
        this.filter1 = null;
      }
    },

    myHierarchies2: function watchMyHierarchies2(arrayIds) {
      if (arrayIds.lenght > 0) {
        const item = this.ih2.listFilters.find(
          (obj) => obj._id === arrayIds[0],
        );
        this.filter2 = item.corporate_name;
      } else {
        this.filter2 = null;
      }
    },

    myIh2: function watchMyIh2(value) {
      if (value !== '0') {
        const item = this.ih2.listFilters.find((obj) => obj._id === value);
        this.filter2 = item.corporate_name;
      } else {
        this.filter2 = null;
      }
    },
  },

  methods: {
    ...mapActions('calendar', ['setDates']),

    returnFilterActionsNames() {
      if (this.myActionName) {
        const namesActions = [];
        for (let i = 0; i < this.allActions.length; i += 1) {
          for (let j = 1; j < this.myActionsIds.length; j += 1) {
            if (this.myActionsIds[j] === this.allActions[i]._id) {
              namesActions.push(this.allActions[i].name);
            }
          }
        }
        return namesActions.join(', ');
      }

      return '-';
    },

    returnActionName() {
      const action = this.listAllActions.find(
        (item) => item._id === this.myActionsIds[0],
      );

      if (action && action !== undefined) {
        return action.name;
      }
      return 'Todas as ações';
    },

    selectOption(dates) {
      if (dates === 'Hoje') {
        this.calculateToday();
      }

      if (dates === 'Ontem') {
        this.calculateYesterday();
      }

      if (dates === 'Últimos 30 dias') {
        this.calculateLast30Days();
      }

      if (dates === 'Mês atual') {
        this.calculateCurrentMonth();
      }

      if (dates === 'Mês anterior') {
        this.calculateLastMonth();
      }
      if (dates === 'Ano atual') {
        this.calculateCurrentYear();
      }

      if (dates === 'Ano anterior') {
        this.calculateLastYear();
      }

      if (dates === 'Todo período') {
        this.allPeriod();
      }

      const filter = this.customFilters.find((item) => item.name === dates);

      if (filter) {
        this.calendarDates.selected = filter.name;

        this.formattedDate.start = moment(filter.start).format('YYYY-MM-DD');
        this.formattedDate.end = moment(filter.end).format('YYYY-MM-DD');

        this.myDates.start = new Date(filter.start);
        this.myDates.end = new Date(filter.end);
        this.myDates.selected = this.calendarDates.selected;

        this.setDates({
          start: this.formattedDate.start,
          end: this.formattedDate.end,
          selected: this.calendarDates.selected,
        });

        EventBus.$emit('change-dates', dates);
      }
    },

    calculateToday() {
      this.formattedDate.start = this.dateFormat(new Date());
      this.formattedDate.end = this.dateFormat(new Date());
      this.myDates.start = new Date();
      this.myDates.end = new Date();

      this.calendarDates.selected = 'Hoje';

      this.setDates({
        start: this.formattedDate.start,
        end: this.formattedDate.end,
        selected: this.calendarDates.selected,
      });

      EventBus.$emit('change-dates', this.calendarDates.selected);
    },

    calculateYesterday() {
      this.formattedDate.start = this.dateFormat(
        new Date(new Date().setDate(new Date().getDate() - 1)),
      );

      this.formattedDate.end = this.dateFormat(
        new Date(new Date().setDate(new Date().getDate() - 1)),
      );

      this.myDates.start = new Date(
        new Date().setDate(new Date().getDate() - 1),
      );

      this.calendarDates.selected = 'Ontem';

      this.myDates.end = new Date(new Date().setDate(new Date().getDate() - 1));
      this.setDates({
        start: this.formattedDate.start,
        end: this.formattedDate.end,
        selected: this.calendarDates.selected,
      });

      EventBus.$emit('change-dates', this.calendarDates.selected);
    },

    calculateLast30Days() {
      this.formattedDate.start = this.dateFormat(
        new Date(new Date().setDate(new Date().getDate() - 30)),
      );

      this.formattedDate.end = this.dateFormat(new Date());
      this.myDates.start = new Date(
        new Date().setDate(new Date().getDate() - 30),
      );

      this.calendarDates.selected = 'Últimos 30 dias';

      this.myDates.end = new Date(new Date());
      this.setDates({
        start: this.formattedDate.start,
        end: this.formattedDate.end,
        selected: this.calendarDates.selected,
      });

      EventBus.$emit('change-dates', this.calendarDates.selected);
    },

    calculateCurrentMonth() {
      const date = new Date();
      const y = date.getFullYear();
      const m = date.getMonth();
      const firstDay = new Date(y, m, 1);
      const lastDay = new Date(y, m + 1, 0);
      this.formattedDate.start = this.dateFormat(firstDay);
      this.formattedDate.end = this.dateFormat(lastDay);
      this.myDates.start = firstDay;
      this.myDates.end = lastDay;

      this.calendarDates.selected = 'Mês atual';

      this.setDates({
        start: this.formattedDate.start,
        end: this.formattedDate.end,
        selected: this.calendarDates.selected,
      });

      EventBus.$emit('change-dates', this.calendarDates.selected);
    },

    calculateLastMonth() {
      const date = new Date();
      const y = date.getFullYear();
      const m = date.getMonth();
      const firstDay = new Date(y, m - 1, 1);
      const lastDay = new Date(y, m, 0);
      this.formattedDate.start = this.dateFormat(firstDay);
      this.formattedDate.end = this.dateFormat(lastDay);
      this.myDates.start = firstDay;
      this.myDates.end = lastDay;

      this.calendarDates.selected = 'Mês anterior';

      this.setDates({
        start: this.formattedDate.start,
        end: this.formattedDate.end,
        selected: this.calendarDates.selected,
      });

      EventBus.$emit('change-dates', this.calendarDates.selected);
    },

    calculateCurrentYear() {
      if (!this.isInviteStatus) {
        const date = new Date();
        // pega primeiro dia do ano
        date.setMonth(0);
        date.setFullYear(date.getFullYear());
        date.setDate(1);
        this.formattedDate.start = this.dateFormat(date);
        this.formattedDate.end = this.dateFormat(new Date());
        this.myDates.start = date;
        this.myDates.end = new Date();

        this.calendarDates.selected = 'Ano atual';

        this.setDates({
          start: this.formattedDate.start,
          end: this.formattedDate.end,
          selected: this.calendarDates.selected,
        });
      } else {
        this.calculateLast120Days('Ano atual');
      }

      EventBus.$emit('change-dates', this.calendarDates.selected);
    },

    calculateLastYear() {
      const date = new Date();
      const y = date.getFullYear();
      const startDateLastYear = new Date(y - 1, 0, 1);
      const endDateLastYear = new Date(y - 1, 11, 31);
      this.formattedDate.start = this.dateFormat(startDateLastYear);
      this.formattedDate.end = this.dateFormat(endDateLastYear);
      this.myDates.start = startDateLastYear;
      this.myDates.end = endDateLastYear;

      this.calendarDates.selected = 'Ano anterior';

      this.setDates({
        start: this.formattedDate.start,
        end: this.formattedDate.end,
        selected: this.calendarDates.selected,
      });

      EventBus.$emit('change-dates', this.calendarDates.selected);
    },

    calculateLast120Days(period) {
      this.formattedDate.start = this.dateFormat(
        new Date(new Date().setDate(new Date().getDate() - 120)),
      );

      this.formattedDate.end = this.dateFormat(new Date());
      this.myDates.start = new Date(
        new Date().setDate(new Date().getDate() - 120),
      );

      this.calendarDates.selected = period.toString();

      this.myDates.end = new Date(new Date());
      this.setDates({
        start: this.formattedDate.start,
        end: this.formattedDate.end,
        selected: this.calendarDates.selected,
      });

      EventBus.$emit('change-dates', this.calendarDates.selected);
    },

    checkTimePeriod() {
      // if (this.$route.path === '/reports') {
      //   const currentDate = new Date();
      //   const firstDayPreviousMonth = new Date(
      //     currentDate.getFullYear(),
      //     currentDate.getMonth() - 1,
      //     1,
      //   );
      //   this.myDates.start = firstDayPreviousMonth;
      //   this.myDates.end = currentDate;
      //   this.myDates.selected = this.calendarDates.selected;

      //   this.calendarDates.start = this.dateFormat(firstDayPreviousMonth);
      //   this.calendarDates.end = this.dateFormat(currentDate);

      //   this.calendarDates.selected = 'Personalizado';
      // }

      if (this.consumption) {
        const currentDate = new Date();
        const firstDayPreviousMonth = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          1,
        );
        this.myDates.start = firstDayPreviousMonth;
        this.myDates.end = currentDate;
        this.myDates.selected = this.calendarDates.selected;

        this.calendarDates.start = this.dateFormat(firstDayPreviousMonth);
        this.calendarDates.end = this.dateFormat(currentDate);
      } else {
        this.myDates.start = this.calendarDates.start;
        this.myDates.end = this.calendarDates.end;
        this.myDates.selected = this.calendarDates.selected;

        this.calendarDates.selected = this.calendarDates.selected;
      }
    },

    showPeriod() {
      if (this.calendarDates.start === null) {
        return this.$t('dashboard.everyPeriodFilter');
      }

      return `${this.dateBrazillianFormat(
        this.myDates.start,
      )} à ${this.dateBrazillianFormat(this.myDates.end)}`;
    },

    dateFormat(param) {
      const date = format(param, 'yyyy-MM-dd');
      return date;
    },

    dateBrazillianFormat(param) {
      const date = new Date(param);
      date.setHours(date.getHours() + 3);
      const result = lightFormat(new Date(date), 'dd/MM/yyyy');
      return result;
    },

    async allPeriod() {
      // EventBus.$emit('refresh', true);
      if (this.isInviteStatus === false) {
        this.checkTimePeriod();

        this.calendarDates.selected = 'Todo período';

        await this.setDates({
          start: null,
          end: null,
          selected: this.calendarDates.selected,
        });

        if (this.dates) {
          this.dates.start = null;
          this.dates.end = +new Date();
        }
      } else {
        this.calculateLast120Days('Todo período');
      }

      EventBus.$emit('change-dates', this.calendarDates.selected);
    },

    async refreshData() {
      if (this.calendarDates.selected === 'Hoje') {
        this.calculateToday();
      }

      if (this.calendarDates.selected === 'Ontem') {
        this.calculateYesterday();
      }

      if (this.calendarDates.selected === 'Últimos 30 dias') {
        this.calculateLast30Days();
      }

      if (this.calendarDates.selected === 'Mês atual') {
        this.calculateCurrentMonth();
      }

      if (this.calendarDates.selected === 'Mês anterior') {
        this.calculateLastMonth();
      }

      if (this.calendarDates.selected === 'Ano atual') {
        this.calculateCurrentYear();
      }

      if (this.calendarDates.selected === 'Ano anterior') {
        this.calculateLastYear();
      }

      if (this.calendarDates.selected === 'Todo período') {
        this.allPeriod();
      }

      if (this.calendarDates.selected === 'Personalizado') {
        await this.setDates({
          start: this.calendarDates.start,
          end: this.calendarDates.end,
          selected: this.calendarDates.selected,
        });
      }
    },

    changeCalendarLanguage() {
      switch (this.$i18n.locale) {
        case 'br':
          this.countryLanguage = 'pt';
          break;
        case 'co':
          this.countryLanguage = 'es';
          break;
        case 'us':
          this.countryLanguage = 'en';
          break;
        default:
          break;
      }
    },

    getCustomFilters() {
      this.customFilters = this.company.customFilters || [];
    },

    changeLabels() {
      this.fastFilter = [
        {
          value: 'Hoje',
          text: this.$t('dashboard.todayFilter'),
        },
        { value: 'Ontem', text: this.$t('dashboard.yesterdayFilter') },
        {
          value: 'Últimos 30 dias',
          text: this.$t('dashboard.last30DaysFilter'),
        },
        { value: 'Mês atual', text: this.$t('dashboard.currentMonthFilter') },
        { value: 'Mês anterior', text: this.$t('dashboard.lastMonthFilter') },
        { value: 'Ano atual', text: this.$t('dashboard.currentYearFilter') },
        { value: 'Ano anterior', text: this.$t('dashboard.lastYearFilter') },
        { value: 'Todo período', text: this.$t('dashboard.everyPeriodFilter') },

        {
          value: 'Personalizado',
          text: this.$t('dashboard.custom'),
          disabled: true,
        },
      ];
      if (this.noAllPeriod) {
        this.fastFilter.splice(7, 1);
      }
    },

    labelsReportMonitoring() {
      this.fastFilter = [
        {
          value: 'Hoje',
          text: this.$t('dashboard.todayFilter'),
        },
        { value: 'Ontem', text: this.$t('dashboard.yesterdayFilter') },
        {
          value: 'Últimos 30 dias',
          text: this.$t('dashboard.last30DaysFilter'),
        },
        { value: 'Mês atual', text: this.$t('dashboard.currentMonthFilter') },
        { value: 'Mês anterior', text: this.$t('dashboard.lastMonthFilter') },
        { value: 'Ano atual', text: this.$t('dashboard.currentYearFilter') },
        { value: 'Ano anterior', text: this.$t('dashboard.lastYearFilter') },
        {
          value: 'Personalizado',
          text: this.$t('dashboard.custom'),
          disabled: true,
        },
      ];

      if (this.noAllPeriod) {
        this.fastFilter.splice(7, 1);
      }
    },

    labelsInviteStatus() {
      this.fastFilter = [
        {
          value: 'Hoje',
          text: this.$t('dashboard.todayFilter'),
        },
        { value: 'Ontem', text: this.$t('dashboard.yesterdayFilter') },
        {
          value: 'Últimos 30 dias',
          text: this.$t('dashboard.last30DaysFilter'),
        },
        { value: 'Mês atual', text: this.$t('dashboard.currentMonthFilter') },
        { value: 'Mês anterior', text: this.$t('dashboard.lastMonthFilter') },
        { value: 'Ano atual', text: this.$t('dashboard.currentYearFilter') },
        { value: 'Todo período', text: this.$t('dashboard.everyPeriodFilter') },
        {
          value: 'Personalizado',
          text: this.$t('dashboard.custom'),
          disabled: true,
        },
      ];
      if (this.noAllPeriod) {
        this.fastFilter.splice(7, 1);
      }
    },
  },
  computed: {
    ...mapState('actions', ['myActionName', 'myActionsIds', 'allActions', 'actionGroupData']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['company', 'myMetric']),
    ...mapState('branches', [
      'myIh1',
      'myIh2',
      'ih1',
      'ih2',
      'myHierarchies1',
      'myHierarchies2',
    ]),
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    if(this.consumption) {
      this.calendarDates.selected = 'Mês atual';
    }
    this.checkTimePeriod();

    if (
      this.$route.name === 'Schedulings' ||
      this.$route.name === 'Reminders'
    ) {
      this.maxDate = null;
    }

    this.refreshData();

    this.changeLabels();
    this.getCustomFilters();

    // this.setDates({
    //   start: null,
    //   end: null,
    // });
  },

  mounted() {
    this.isInviteStatus = false;

    EventBus.$on('changedLanguage', () => {
      this.changeCalendarLanguage();
      this.changeLabels();
    });

    EventBus.$on('isReportMonitoringTreatment', (value) => {
      if (value) {
        this.labelsReportMonitoring();
        this.minDate = null;
      } else {
        this.changeLabels();
      }
      // this.refreshData();
    });

    EventBus.$on('isInviteStatus', (value) => {
      if (value) {
        this.labelsInviteStatus();
        this.isInviteStatus = true;
        this.minDate = new Date(new Date().setDate(new Date().getDate() - 120));
      } else {
        this.changeLabels();
        this.isInviteStatus = false;
      }
      // this.refreshData();
    });

    EventBus.$on('changeReport', (value) => {
      if (value) {
        this.minDate = null;
      }
      this.isInviteStatus = false;
      // this.refreshData();
    });

    this.checkTimePeriod();

    if (this.myIh1 !== '0') {
      const item = this.ih1.listFilters.find((obj) => obj._id === this.myIh1);
      this.filter1 = item.corporate_name;
    } else {
      this.filter1 = null;
    }
    if (this.myIh2 !== '0') {
      const item = this.ih2.listFilters.find((obj) => obj._id === this.myIh2);
      this.filter2 = item.corporate_name;
    } else {
      this.filter2 = null;
    }

    EventBus.$on('apply-filter-menu', async () => {
      this.loadingActionSelected = true;
      const allActions = await api.get(
        `/filters/actions/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            type: this.myMetric,
            groupId: this.actionGroupData._id
          },
        },
      );

      this.listAllActions = allActions.data;
      this.loadingActionSelected = false;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.wrapper {
  border: 1px solid $gray-light;
  border-radius: 4px;
  position: relative;
  height: 65px;
  width: 100%;
  background-color: $white;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  color: $title-color;
  padding: 0 8px;
  font-size: 0.9em;
  > div {
    border-right: 1px solid $gray-light;
    padding: 8px 16px 8px 8px;
    &:last-of-type {
      border-right: none;
    }
  }
  .calendar-icon {
    color: $primary;
    cursor: pointer;
    &:hover {
      color: rgb(97, 209, 97);
      ~ .calendar {
        display: block;
      }
    }
  }
  .volumes {
    display: flex;
    position: absolute;
    right: 8px;
    padding: 8px;
    > div {
      text-align: center;
      padding: 0 32px;
      border-right: 1px solid $gray-light;
      &:first-of-type {
        border-left: 1px solid $gray-light;
      }
      &:last-of-type {
        border-right: none;
      }
    }
    span {
      font-weight: 100;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/dashboard-bar/index.vue